import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_18 = { class: "col-md-12" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = { class: "col-md-4" }
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_28 = { class: "form-check mb-2" }
const _hoisted_29 = { class: "form-check mb-2" }
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = { class: "col-md-12" }
const _hoisted_32 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "ruleForm",
        onSubmit: _ctx.addRule,
        "validation-schema": _ctx.ruleSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-12 mb-3" }, [
              _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                _createElementVNode("i", { class: "ri-information-line" }),
                _createTextVNode(" Informations générales ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[0] || (_cache[0] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Jeu de règles "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "rule_set_id" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.ruleSetOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner le jeu de règles"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "rule_set_id",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Code "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "code",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le code"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "code",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Libellé "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "name",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le libellé"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "name",
                  class: "text-danger"
                })
              ])
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "col-12 mb-3 mt-3" }, [
              _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                _createElementVNode("i", { class: "ri-settings-3-line" }),
                _createTextVNode(" Configuration de la règle ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type d'entité ciblée "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "target_entity_type" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.targetOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner le type d'entité"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "target_entity_type",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Sévérité "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "severity" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.severityOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner la sévérité"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "severity",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type d'auto-flag "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "auto_flag_type" }, {
                  default: _withCtx(({ value, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: value,
                      "onUpdate:modelValue": handleChange,
                      options: _ctx.autoFlagTypeOptions,
                      label: "label",
                      "track-by": "value",
                      valueProp: "value",
                      placeholder: "Sélectionner le type d'alerte"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "auto_flag_type",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Description "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "description",
                  as: "textarea",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Description...",
                  rows: "3"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "description",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Expression de condition ", -1)),
                _createVNode(_component_Field, {
                  name: "condition_expression",
                  as: "textarea",
                  class: "form-control shadow-none fs-md-15 text-black",
                  rows: "4",
                  placeholder: "Expression JSON ou condition métier..."
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "condition_expression",
                  class: "text-danger"
                }),
                _cache[8] || (_cache[8] = _createElementVNode("small", { class: "text-muted" }, "Format JSON pour définir la logique de contrôle", -1))
              ])
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-12 mb-3 mt-3" }, [
              _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                _createElementVNode("i", { class: "ri-calendar-line" }),
                _createTextVNode(" Période d'application ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date d'entrée en vigueur ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_from",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date de fin d'application ", -1)),
                _createVNode(_component_Field, {
                  name: "effective_to",
                  type: "date",
                  class: "form-control shadow-none fs-md-15 text-black"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Activer", -1)),
                _createVNode(_component_Field, {
                  name: "is_enabled",
                  type: "checkbox",
                  class: "form-check-input",
                  value: true,
                  "unchecked-value": false
                })
              ])
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-12 mb-3 mt-3" }, [
              _createElementVNode("h6", { class: "text-primary fw-semibold border-bottom pb-2" }, [
                _createElementVNode("i", { class: "ri-time-line" }),
                _createTextVNode(" Moments d'exécution ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Moments d'exécution", -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Field, {
                    name: "run_on_creation",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "runOnCreation",
                    value: true,
                    "unchecked-value": false
                  }),
                  _cache[12] || (_cache[12] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "runOnCreation"
                  }, " Exécuter à la création/soumission du dossier ", -1))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_Field, {
                    name: "run_on_update",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "runOnUpdate",
                    value: true,
                    "unchecked-value": false
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "runOnUpdate"
                  }, " Exécuter lors des mises à jour ", -1))
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    name: "run_on_pre_issuance",
                    type: "checkbox",
                    class: "form-check-input",
                    id: "runOnPreIssuance",
                    value: true,
                    "unchecked-value": false
                  }),
                  _cache[14] || (_cache[14] = _createElementVNode("label", {
                    class: "form-check-label",
                    for: "runOnPreIssuance"
                  }, " Exécuter obligatoirement avant émission (contrôle bloquant) ", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _cache[17] || (_cache[17] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Ajouter règle de contrôle individuelle ", -1)),
                _createVNode(_component_router_link, {
                  to: "/listeRule",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}